module.exports = __webpack_public_path__ + "img/lixo.84774066.svg";